export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_20.fa739ad0.jpg";